import { Pipe, PipeTransform } from '@angular/core';
import { RuleStatus } from '@app/shared/models/geokingRule';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'reviewStatusParser',
})
export class ReviewParserPipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}
  transform(rs: RuleStatus): string {
    switch (rs) {
      case RuleStatus.ACTIVE:
        return this.translateService.instant('POSTS.ACTIVE');
      case RuleStatus.EXPIRED:
        return this.translateService.instant('POSTS.EXPIRED');
      case RuleStatus.INACTIVE:
        return this.translateService.instant('POSTS.INACTIVE');
      default:
        return '';
    }
  }
}
